export default __webpack_public_path__ + "static/pxp-integration-automation-a801938b1ad30e1930c05a2bd3d77f15.webp";